import { Component, OnInit, Input } from '@angular/core';
import { MenuItem } from '@models/menu-item';

@Component({
  standalone: false,
  selector: 'app-item-title',
  templateUrl: './item-title.component.html',
  styleUrls: ['./item-title.component.scss']
})
export class MenuItemTitleComponent implements OnInit {
  @Input()
  item: MenuItem;

  @Input()
  mode: number;

  constructor() { }

  ngOnInit(): void { }
}
